import React from 'react'
import { CoreContainer } from '@hub/core-container'
import { SGPageTemplateProductCollection } from '../../../../../../src/types/page-templates'
import { CollectionDeck } from '../../../../../../src/shared/hub-components/collection-deck'
import { ModuleProps } from '../../types'

const COLLECTION_DECK_MAX_PRODUCTS = 3

export default function SGPageTemplateContentCollectionDeckModule({
  module,
}: ModuleProps<SGPageTemplateProductCollection>): JSX.Element | null {
  if (!module.title || !module.url || !module.image) {
    return null
  }

  const products = module.items.slice(0, COLLECTION_DECK_MAX_PRODUCTS)
  if (products.length === 0) {
    return null
  }

  return (
    <CoreContainer>
      <CollectionDeck
        title={module.title}
        text={module.shortDescription}
        url={module.url}
        image={module.image}
        products={products}
      />
    </CoreContainer>
  )
}
